import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SellOnlineLeadStepContainer from "./component";
import { setData, setStep, mergeLeadData, resetSellOnlineLeadData} from "./actions";
import { mergeNonSoLeadData} from "../lead-form/actions";
import { withRouter } from "react-router-dom";
import { fetchLeadDetails, setFetchLeadDetail} from "../appointment/actions";
import { setName, setMobile } from "../../configuration/actions";
import { updateLeadType } from "../../../components/configuration/actions";
import { setOfferPrice, isSubmittingData} from "../sell-online-offer-price/actions";
import {setLeadMobile, resetLeadFormData} from "../../../components/desktop/lead-form/actions";
import {submitAppointmentFailure} from "../../../components/desktop/book-appointment-form/actions";
import withLayout from "../layout/component";
import { getCmsPageTemplateData } from "../appointment-v2/actions";

const mapStateToProps = ({
    location,
    sellOnlineLeadData,
    sellOnlinePrice: {
        appointmentDetails
    },
    appointmentLocation: {
        isFetching
    },
    confirmationDetails: { details },
    reschedule,
    user: {secureToken}
}) => ({
    location,
    details,
    reschedule,
    sellOnlineLeadData,
    appointmentDetails,
    isFetching,
    secureToken
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setDataConnect: setData,
    setStepConnect: setStep,
    setMobileConnect: setMobile,
    setNameConnect: setName,
    setOfferPriceConnect: setOfferPrice,
    mergeLeadDataConnect: mergeLeadData,
    updateLeadTypeConnect: updateLeadType,
    fetchLeadDetailsConnect: fetchLeadDetails,
    isSubmittingDataConnect: isSubmittingData,
    resetSellOnlineLeadDataConnect: resetSellOnlineLeadData,
    setLeadMobileConnect: setLeadMobile,
    resetLeadFormDataConnect: resetLeadFormData,
    submitAppointmentFailureConnect: submitAppointmentFailure,
    mergeNonSoLeadDataConnect: mergeNonSoLeadData,
    setFetchLeadDetailConnect: setFetchLeadDetail,
    getCmsPageTemplateDataConnect: getCmsPageTemplateData
}, dispatch);

export default withRouter(withLayout(connect(mapStateToProps, mapDispatchToProps)(SellOnlineLeadStepContainer), false, false, false, false));
